import React, {useEffect, useState} from "react";
import { IProfile } from '../../../interface/IProfile.ts';
import { useProfileApi } from '../../../features/auth/hooks/use-profile-api.ts'
import { ApiResponseType } from "../../../features/api/types.ts";
import { useListsApi } from "../../../features/auth/hooks/use-lists-api.ts";
import { IOption } from "../../../interface/IOption.ts";
import Checkboxes from "../../Form/Checkboxes.tsx";
import Form from "../../Form/Form.tsx";
import ApiCheck from '../../Structure/ApiCheck.tsx';

const TabRemunerationModel = ({
    profile,
    setProfile
}:{
    profile:IProfile
    setProfile: Function
}) => {
    const [compensationList, setCompensationList] = useState<Array<any>>([]);
    const [compensationLoading, setCompensationLoading] = useState<boolean>(true);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState<string>('');
    const { postProfile } = useProfileApi();
    const [errors, setErrors] = useState<any>({});
    const { getList } = useListsApi();
    const [apiErrors, setApiErrors] = useState<any>();

    const [unSavedChanges, setUnSavedChanges] = useState(false);
    
    const [formData, setFormData] = useState<IProfile>({
        compensation: profile.compensation ?? [],
    });

    const handleChange = (event, name = '', value = null) => {
        setFormData({ ...formData, [name ? name : event.target.name]: value ? value : event.target.value });
        !unSavedChanges && setUnSavedChanges(true);
    };

    const expectedAmountCompensations:number = 2;

    const handleSubmit = (event) => {
        event.preventDefault();
        setUnSavedChanges(false);
        setIsLoading(true);

        let postedData:{compensation:Array<string>} = {
            compensation: [],
        };
        let compensationIds = formData.compensation!.map(el => {
            return el.value;
        });
        postedData.compensation = compensationIds;

        setErrors({});
        postProfile(postedData).then(res => {
            setIsLoading(false);
            if (res.type === ApiResponseType.OK) {
                if (res.payload.success)  {
                    setResponseMessage('Erfolgreich gespeichert');
                    setResponseMessageClass('success');
                    setProfile({...profile, ...postedData});
                    setTimeout(() => {
                        setResponseMessage('');
                    }, 5000);
                }
            } else {
                let errors = res.payload.errors!;
                if (!errors.general_error) {
                    setResponseMessage('Fehler. Bitte korrigieren Sie den Fehler und versuchen Sie es erneut.');
                    setResponseMessageClass('error');
                }
                setErrors(errors);
            }
        })
    }

    useEffect(() => {
        let formDataClone = structuredClone(formData);
        getList('compensation').then(res => {
            let optionList:Array<IOption> = [];
            if (res) {
                res.forEach((item:any) => {
                    optionList.push({
                        value: item.id,
                        label: item.label
                    });
                });
                setCompensationList(optionList);
                let compensationsFromOptions:Array<IOption> = [];
                compensationsFromOptions = optionList.filter(singleCompensationOption => {
                    return profile.compensation?.includes(singleCompensationOption.value);
                });
                formDataClone = { ...formDataClone, compensation: compensationsFromOptions }
                setFormData(formDataClone);
                setCompensationLoading(false);
            }
        }).catch(() => {
            setApiErrors({
                errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
            });
            setCompensationLoading(false);
        });
    }, []);

    return (
        <div className="single-tab-item">
            <Form
                unSavedChanges={unSavedChanges}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                responseMessage={responseMessage}
                responseMessageClass={responseMessageClass}
                generalErrors={ errors.general_error ? errors.general_error : null}
                intro="Bitte markieren Sie Ihr Vergütungsmodell. Sollten Sie sowohl gegen Honorar als auch gegen Provision arbeiten, wählen Sie bitte beides aus. Die Auswahl ist auch Basis für die Suche auf der FPSB-Webseite."
            >
                { compensationLoading ? (
                    <div className="form-group checkboxes no-label">
                        <div className="checkbox-inputs-wrapper">
                            {[...Array(expectedAmountCompensations)].map((k,i) =>
                                <div className="single-checkbox" key={'cl_' + i}>
                                    <input type="checkbox" disabled />
                                    <label><div className="checkbox-loader"></div></label>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors ? apiErrors : null}>
                        <Checkboxes
                            name='compensation'
                            onChange={(item:IOption, wasChecked:boolean) => {
                                if (wasChecked) {
                                    let x = formData.compensation.filter(el => {
                                        return el.value !== item.value
                                    });
                                    handleChange(null, 'compensation', x);
                                } else {
                                    let x = structuredClone(formData.compensation);
                                    x.push(item);
                                    handleChange(null, 'compensation', x);
                                }
                            }}
                            value={formData?.compensation}
                            options={compensationList}
                            error={errors['compensation']}
                        />
                    </ApiCheck>
                ) }
            </Form>
        </div>
    )
}

export default TabRemunerationModel;